<div class="h-full overflow-auto p-4">
  <div
    class="border-default bg-elevated flex items-center gap-3.5 rounded-lg border px-[18px] py-4">
    <div class="min-w-0">
      <div
        class="text-text-secondary font-mono text-[10px] font-semibold tracking-[0.06em] uppercase">
        {{ timestamp() }}
      </div>
      <h1 class="mt-1 mb-0 text-xl font-semibold tracking-tight">
        {{ greeting() }}
      </h1>
      <div class="text-text-secondary mt-0.5 text-[12.5px]">
        {{ 'home.greeting.context_prefix' | translate }}
        <span class="text-text-primary font-mono">{{ dataspaceName() }}</span>
      </div>
    </div>
  </div>
</div>
